import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { ReactSwal } from '../../../../helpers/swal';

const eventOffConfirmation = (endTime, updateStatusFn, isAdmin) => {
  const yesBtnHandler = (evt) => {
    evt.nativeEvent.stopImmediatePropagation();
    const inviteCheckbox = document.getElementById('sendCalendarInviteEventOff');
    const invite = inviteCheckbox ? inviteCheckbox.checked : true;
    ReactSwal.close();
    // Yes: update event endtime to now and set status to post.
    updateStatusFn(true, invite);
  };

  const noBtnHandler = (evt) => {
    evt.nativeEvent.stopImmediatePropagation();
    ReactSwal.close();
    // No: just set status to post without updating the endtime.
    updateStatusFn(false);
  };

  return ReactSwal.fire({
    title: 'Confirm Event Off',
    type: 'warning',
    showConfirmButton: false,
    showCancelButton: false,
    html: (
      <div>
        <p>
          Event will be off at
          {' '}
          <strong>{endTime}</strong>
          , scheduler may turn it back on shortly.
          Would you like to move that to now?
        </p>
        {isAdmin && (
          <div className="mb-3">
            <Form.Check
              custom
              type="checkbox"
              id="sendCalendarInviteEventOff"
              className="d-inline-block"
              label="Send Calendar Invite"
              defaultChecked
            />
          </div>
        )}
        <div className="text-nowrap">
          <Button
            variant="danger"
            className="swal2-confirm btn btn-danger btn-lg"
            onClick={yesBtnHandler}
          >
            Yes, update to now
          </Button>
          &nbsp;
          &nbsp;
          &nbsp;
          <Button
            className="swal2-confirm btn btn-danger btn-lg bg-white"
            variant="default"
            onClick={noBtnHandler}
            autoFocus
          >
            No, just set to Post
          </Button>
        </div>
      </div>
    ),
  });
};

export default eventOffConfirmation;
